// react
import React from "react";
import PropTypes from "prop-types";

// dependencies
import { List, isImmutable } from "immutable";
import { CheckCircle2, Circle } from "lucide-react";

// style
import css from "./Radio.styl";

export default class RadioInput extends React.Component {
	static propTypes = {
		onChange: PropTypes.func.isRequired,
		value: PropTypes.string.isRequired,
		options: PropTypes.oneOfType([
			PropTypes.instanceOf(List),
			PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
				})
			),
		]).isRequired,
		disabled: PropTypes.bool,
	};

	static defaultProps = {
		disabled: false,
	};

	handleChange = (value, disabled) => {
		if (!disabled) {
			let newValue = value;

			if (value === this.props.value) {
				newValue = null;
			}

			this.props.onChange(newValue);
		}
	};

	render = () => {
		const { value, disabled } = this.props;
		const mainClassName = disabled ? css.disabled : css.Main;

		let options = this.props.options;

		if (isImmutable(this.props.options)) {
			options = this.props.options.toJS();
		}

		return (
			<div className={mainClassName}>
				{options.map((option) => {
					const isActive = option.id === value;
					const IconComponent = isActive ? CheckCircle2 : Circle;
					const activeSubtitle = isActive ? option?.subtitle : null;
					return (
						<div
							key={option.id}
							onClick={() => this.handleChange(option.id, disabled)}
							className={`${css.optionWrapper} ${isActive ? css.isActive : ""}`}
						>
							<div className={css.icon}>
								<IconComponent size={16} />
							</div>
							<div className={css.label}>{option.label}</div>
							{activeSubtitle ? <div className={css.subtitle}>{activeSubtitle}</div> : null}
						</div>
					);
				})}
			</div>
		);
	};
}
